import script from "./empty.vue?vue&type=script&setup=true&lang=js"
export * from "./empty.vue?vue&type=script&setup=true&lang=js"

import "./empty.vue?vue&type=style&index=0&id=ed28f7ce&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed28f7ce"]])

export default __exports__